export default __webpack_public_path__ + "static/webRotator/svg/a52feae2235cc7c368bfbb4d6b9ae485.svg";